
(function(){
  // CUSTOM CURSOR
  const cd=document.getElementById('cd'),cr=document.getElementById('cr');
  let mx=0,my=0,rx=0,ry=0;
  if(cd&&cr&&window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;cd.style.left=mx+'px';cd.style.top=my+'px'});
    (function loop(){rx+=(mx-rx)*.1;ry+=(my-ry)*.1;cr.style.left=rx+'px';cr.style.top=ry+'px';requestAnimationFrame(loop)})();
    document.querySelectorAll('a,button,.svc-c,.pb-card,.tc,.plan-c').forEach(el=>{
      el.addEventListener('mouseenter',()=>document.body.classList.add('ch'));
      el.addEventListener('mouseleave',()=>document.body.classList.remove('ch'));
    });
  }

  // 3D WEBGL-STYLE CANVAS
  const canvas=document.getElementById('bg-canvas');
  const ctx=canvas.getContext('2d');
  let W,H,pts,t=0;
  function resize(){W=canvas.width=window.innerWidth;H=canvas.height=window.innerHeight}
  function mkPts(){pts=[];for(let i=0;i<(W<768?60:130);i++)pts.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.35,vy:(Math.random()-.5)*.35,r:Math.random()*1.6+.4})}
  function draw(){
    t+=.008;
    ctx.clearRect(0,0,W,H);
    // Rotating 3D grid effect
    ctx.save();
    ctx.strokeStyle='rgba(0,224,90,0.025)';
    ctx.lineWidth=1;
    const cx=W/2,cy=H/2,gridSize=80,rot=t*.2;
    for(let x=-W;x<W*2;x+=gridSize){
      const rx2=cx+(x-cx)*Math.cos(rot)-(0)*Math.sin(rot);
      const ry2=cy+(x-cx)*Math.sin(rot)+(0)*Math.cos(rot);
      ctx.beginPath();ctx.moveTo(rx2,0);ctx.lineTo(rx2,H);ctx.stroke();
    }
    ctx.restore();

    // Particles
    for(let i=0;i<pts.length;i++){
      const p=pts[i];
      p.x+=p.vx;p.y+=p.vy;
      if(p.x<0)p.x=W;if(p.x>W)p.x=0;if(p.y<0)p.y=H;if(p.y>H)p.y=0;
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      ctx.fillStyle='rgba(0,224,90,0.6)';ctx.fill();
      for(let j=i+1;j<pts.length;j++){
        const q=pts[j],dx=p.x-q.x,dy=p.y-q.y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<130){ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(q.x,q.y);ctx.strokeStyle=`rgba(0,224,90,${(1-d/130)*.12})`;ctx.lineWidth=.5;ctx.stroke()}
      }
    }

    // Floating 3D hexagons
    for(let h=0;h<4;h++){
      const hx=W*.15+h*(W*.24),hy=H*.5+Math.sin(t+h*1.2)*30,hr=30+h*8;
      ctx.save();ctx.translate(hx,hy);ctx.rotate(t*.3+h*.7);
      ctx.strokeStyle=`rgba(0,224,90,${.04+h*.01})`;ctx.lineWidth=1;
      ctx.beginPath();
      for(let s=0;s<6;s++){const a=s/6*Math.PI*2;ctx.lineTo(Math.cos(a)*hr,Math.sin(a)*hr)}
      ctx.closePath();ctx.stroke();
      ctx.restore();
    }
    requestAnimationFrame(draw);
  }
  resize();mkPts();draw();
  window.addEventListener('resize',()=>{resize();mkPts()},{passive:true});

  // SCROLL REVEALS
  const obs=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target)}})},{threshold:.1});
  document.querySelectorAll('.rev').forEach(el=>obs.observe(el));

  // NAV SCROLL
  const nav=document.getElementById('nav');
  window.addEventListener('scroll',()=>nav&&nav.classList.toggle('sc',scrollY>20),{passive:true});

  // HAMBURGER
  const ham=document.getElementById('ham'),drawer=document.getElementById('drawer');
  if(ham&&drawer){
    ham.addEventListener('click',()=>{ham.classList.toggle('op');drawer.classList.toggle('op')});
    drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{ham.classList.remove('op');drawer.classList.remove('op')}));
  }

  // STAT COUNTERS
  const ss=document.querySelector('.stats-s');
  if(ss){let done=false;
    new IntersectionObserver(es=>{if(es[0].isIntersecting&&!done){done=true;
      document.querySelectorAll('[data-c]').forEach(el=>{
        const tgt=+el.dataset.c,dur=1800,step=tgt/(dur/16);let n=0;
        const ti=setInterval(()=>{n=Math.min(n+step,tgt);el.textContent=Math.floor(n);if(n>=tgt)clearInterval(ti)},16);
      });
    }},{threshold:.4}).observe(ss);
  }

  // 3D TILT for cards
  if(window.matchMedia('(hover:hover)').matches){
    document.querySelectorAll('.svc-c,.pb-card,.tc,.plan-c').forEach(c=>{
      c.addEventListener('mousemove',e=>{
        const r=c.getBoundingClientRect();
        const x=((e.clientX-r.left)/r.width-.5)*14;
        const y=((e.clientY-r.top)/r.height-.5)*-14;
        const px=(e.clientX-r.left)/r.width*100;
        const py=(e.clientY-r.top)/r.height*100;
        c.style.transform=`translateY(-8px) perspective(700px) rotateX(${y}deg) rotateY(${x}deg)`;
        c.style.setProperty('--mx',px+'%');c.style.setProperty('--my',py+'%');
      });
      c.addEventListener('mouseleave',()=>c.style.transform='');
    });
  }

  // FAQ
  document.querySelectorAll('.fq').forEach(b=>b.addEventListener('click',()=>{
    const fi=b.parentElement,op=fi.classList.contains('op');
    document.querySelectorAll('.fi').forEach(i=>i.classList.remove('op'));
    if(!op)fi.classList.add('op');
  }));

  // FORM
  const f=document.getElementById('cform');
  if(f)f.addEventListener('submit',e=>{
    e.preventDefault();
    const n=document.getElementById('fn').value.trim(),em=document.getElementById('fe').value.trim(),br=document.getElementById('fb').value.trim();
    if(!n||!em){alert('Please fill in your name and email.');return}
    const msg=`Hi Fokuszy! I'm ${n}. I'd like a free digital audit for ${br||'my brand'}. Email: ${em}`;
    window.open('https://wa.me/919315442430?text='+encodeURIComponent(msg),'_blank');
  });

  // GLITCH data-t
  document.querySelectorAll('.glitch').forEach(el=>el.dataset.t=el.textContent);
})();
